/* global document */

import template from './accordion.vhtml';
import 'es6-object-assign/auto';

import './accordion.scss';

import {VueSlideToggle} from 'vue-slide-toggle';
import tooltip from '../tooltip/tooltip';

export default {
  name: 'accordion',
  template,
  components: {
    VueSlideToggle,
      tooltip
  },
  props: {
    title: {
      type: String,
      required: true,
    },
    theContent: {
      type: Array,
      default: () => [],
    }
  },
  data() {
		return {
      isOpen: false,
      isSelected: false,
			hasTopContent: false,
			hasContent: false,
			el: this,
		};
  }
};



// WEBPACK FOOTER //
// ./assets/_js/components/accordion/accordion.js